module.exports = __webpack_public_path__ + "static/media/battery-voltage.e467df47.svg";